import React from "react";
import CheckboxBlankCircleOutline from "mdi-material-ui/CheckboxBlankCircleOutline";
import CheckboxMarkedCircle from "mdi-material-ui/CheckboxMarkedCircle";
import LockOutline from "mdi-material-ui/LockOutline";
// ** MUI Imports
import Checkbox from "@mui/material/Checkbox";
import Typo from "src/@core/components/typo";
import Tooltip from "@mui/material/Tooltip";

import { useTheme } from "@mui/material/styles";
import { hexToRGBA } from "src/@core/utils/hex-to-rgba";
import { LessonLength, LessonInfo, AttachmentsInfo } from "./helper";

// ** Hooks
import { useAuth } from "src/hooks/useAuth";

function Lessons({
  videos_info,
  chapter,
  lessons,
  actualChapter,
  actualLesson,
  lessonStatusHandler,
  activeLessonHandler,
  onShowAttachmentsClick,
  lessonsStatus,
  isChapterAvailable,
  isSmallDevice = false,
  showLessonNumbers,
}) {
  const auth = useAuth();
  const theme = useTheme();
  //console.log("Lessons -> lessons", showLessonNumbers);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const selectedColor = theme.palette.mode === "dark" ? theme.palette.common.white : theme.palette.common.black;

  return (
    <div style={{ display: "block" }} className="lessons-container">
      {lessons.map((lesson, index) => {
        // `=== true` is required, not cosmetic: a lesson with no status entry yields `undefined`,
        // which makes MUI's Checkbox uncontrolled for its whole lifetime (useControlled locks on the
        // first render). It would then keep the ring grey/green from the class while ignoring `checked`,
        // so a lesson completed later showed a green ring with no tick.
        const isCompleted = lessonsStatus?.find((el) => el.lesson_id === lesson.lesson_id)?.completed === true;
        const activeLesson = lesson.lesson_id === actualLesson;
        const isQuestionnaireLesson = lesson.lesson_type === "questionnaire";
        /** When false, clicks on the completion control should bubble to the lesson row (open lesson). */
        const completionCheckboxInteractive = isChapterAvailable === true && isQuestionnaireLesson !== true;
        let completionTooltip = isCompleted === true ? "Desmarcar como concluída" : "Marcar como concluída";
        if (isQuestionnaireLesson === true) {
          completionTooltip =
            isCompleted === true ? "Aula concluída após submeter o questionário." : "A conclusão desta aula depende de submeteres o questionário.";
        }

        return (
          <div
            key={index}
            // style={{
            //   backgroundColor: lesson.lesson_id === actualLesson ? hexToRGBA(selectedColor, 0.1) : "",
            // }}
            className={`${isSmallDevice ? "mobile-lesson-item" : "lesson-item"} ${activeLesson ? "active" : ""} ${
              isChapterAvailable === true ? "" : "lesson-locked"
            }`}
            onClick={() => {
              activeLessonHandler(chapter, lesson.lesson_id);
              scrollToTop();
            }}
          >
            <div className={isSmallDevice ? "mobile-lesson-item-container" : "lesson-item-container"}>
              <Tooltip title={completionTooltip} placement="right">
                {/* Span required: Tooltip does not receive pointer events on a disabled Checkbox */}
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    verticalAlign: "middle",
                  }}
                  onClick={(e) => {
                    if (completionCheckboxInteractive === true) {
                      e.stopPropagation();
                    }
                  }}
                >
                  <Checkbox
                    icon={<CheckboxBlankCircleOutline sx={{ fontSize: "1.5rem" }} />}
                    checkedIcon={<CheckboxMarkedCircle sx={{ fontSize: "1.5rem" }} />}
                    disabled={!isChapterAvailable || isQuestionnaireLesson === true}
                    disableRipple
                    checked={isCompleted}
                    className={isSmallDevice ? `mobile-chk-lesson-status ${isCompleted ? "checked" : ""}` : `chk-lesson-status ${isCompleted ? "checked" : ""}`}
                    name="basic-unchecked"
                    onClick={(e) => {
                      if (completionCheckboxInteractive === true) {
                        e.stopPropagation();
                      }
                    }}
                    onChange={(e) => {
                      if (isQuestionnaireLesson === true) {
                        return;
                      }
                      lessonStatusHandler(chapter, lesson.lesson_id, e.target.checked);
                    }}
                  />
                </span>
              </Tooltip>

              <div style={{ display: "block" }}>
                <Typo align={"left"} append={<AttachmentsInfo lesson={lesson} onClick={onShowAttachmentsClick} />}>
                  <div className={`${isSmallDevice ? "mobile-lesson-title" : "lesson-title"} ${lesson.lesson_id === actualLesson ? "active" : ""}`}>
                    <LessonInfo lesson={lesson} />{" "}
                    <div>
                      {showLessonNumbers && <span>{index + 1}. </span>}
                      {lesson.title}
                    </div>
                  </div>
                </Typo>
                {isChapterAvailable && <LessonLength videos_info={videos_info} lesson={lesson} />}
              </div>
              {isChapterAvailable !== true && (
                <span className="lesson-lock" title="Disponível em breve">
                  <LockOutline />
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Lessons;
